define('notifications_order_outofstockitems.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('notifications_order_outofstockitems', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"hasMessage") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":74}}})) != null ? stack1 : "")
    + " ";
},"1":function(container,depth0,helpers,partials,data) {
    return " <div data-view=\"OutOfStock.Notification\"></div> ";
},"useData":true}, 'extensions/ES/MaxaMasterTheme/24.1.1/', 'extensions/ES/MaxaMasterTheme/24.1.1/', Handlebars);
});